// import React, { useEffect, useState } from 'react';
// import Style from '../doctors/doctor.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import { Button, Card, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { IconButton, Tooltip } from '@mui/material';
// import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
// import { toast } from 'react-toastify';
// import { getMedicines, addMedicine, updateMedicine, deleteMedicine } from '../../apis/medicineSlice';
// import SearchClinic from '../../components/Autocomplete/SearchClinic';

// export default function Medicine() {
//   const dispatch = useDispatch();
//   const { medicines, loading } = useSelector((state) => state.medicineData || { medicines: [], loading: false });

//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);

//   const [openPopup, setOpenPopup] = useState(false);
//   const [medicineData, setMedicineData] = useState({ name: '', clinicId: null });
//   const [editId, setEditId] = useState(null);

//   useEffect(() => {
//     dispatch(getMedicines({ page, pageSize }));
//   }, [dispatch, page, pageSize]);

//   const handleOpenAdd = () => {
//     setEditId(null);
//     setMedicineData({ name: '', clinicId: null });
//     setOpenPopup(true);
//   };

//   const handleOpenEdit = (row) => {
//     setEditId(row._id);
//     setMedicineData({ name: row.name, clinicId: row.clinicId || null });
//     setOpenPopup(true);
//   };

//   const handleSubmit = async () => {
//     if (!medicineData.name || !medicineData.name.trim()) {
//       toast.error('Name is required');
//       return;
//     }

//     let response;

//     if (editId) {
//       response = await dispatch(updateMedicine({ id: editId, name: medicineData.name, clinicId: medicineData.clinicId }));
//     } else {
//       response = await dispatch(addMedicine({ name: medicineData.name, clinicId: medicineData.clinicId }));
//     }

//     if (response?.payload?.message) {
//       toast.success(response.payload.message);
//       setOpenPopup(false);
//       dispatch(getMedicines({ page, pageSize }));
//     } else {
//       toast.error(response?.payload?.message || 'Error');
//     }
//   };

//   const handleDelete = async (row) => {
//     if (!window.confirm('Are you sure to delete this medicine?')) return;
//     const response = await dispatch(deleteMedicine(row._id));

//     if (response?.payload?.message) {
//       toast.success(response.payload.message);
//       dispatch(getMedicines({ page, pageSize }));
//     } else {
//       toast.error('Error deleting medicine');
//     }
//   };

//   const columns = [
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 160,
//       sortable: false,
//       renderCell: (params) => (
//         <div style={{ display: 'flex', gap: 8 }}>
//           <Tooltip title="Edit">
//             <IconButton color="primary" onClick={() => handleOpenEdit(params.row)}>
//               <EditIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Delete">
//             <IconButton color="error" onClick={() => handleDelete(params.row)}>
//               <DeleteIcon />
//             </IconButton>
//           </Tooltip>
//         </div>
//       ),
//     },
//  {
//   field: 'clinicName',
//   headerName: 'Clinic Name',
//   width: 200,
//   renderCell: (params) => (
//     <span style={{ textTransform: 'capitalize' }}>
//       {params.row?.clinicId?.name || 'N/A'}
//     </span>
//   ),
// },
//         { field: 'name', headerName: 'Name', width: 300 },
//   ];

//   return (
//     <div className={Style.mainDataTable}>
//       <Card className={Style.tableCard}>
//         <div className={Style.tableHeader}>
//           <h2 className={Style.tableTitle}>Medicines</h2>
//           <Button className={Style.addBtn} variant="contained" startIcon={<LocalPharmacyIcon />} onClick={handleOpenAdd}>
//             Add Medicine
//           </Button>
//         </div>
//         <DataGrid
//           rows={medicines || []}
//           columns={columns}
//           getRowId={(row) => row._id}
//           loading={loading}
//           autoHeight
//           pagination
//           pageSize={pageSize}
//           onPageChange={(newPage) => setPage(newPage)}
//           onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//         />
//       </Card>

//       <Dialog open={openPopup} fullWidth maxWidth={'sm'} onClose={() => setOpenPopup(false)}>
//         <DialogTitle>{editId ? 'Edit Medicine' : 'Add Medicine'}</DialogTitle>

//         <DialogContent>
//           <div style={{ marginBottom: 12 }}>
//             <SearchClinic open={openPopup} setData={setMedicineData} data={medicineData} name="clinicId" label="Clinic" size="small" />
//           </div>
//           <TextField autoFocus margin="dense" label="Medicine Name" fullWidth value={medicineData.name} onChange={(e) => setMedicineData((prev) => ({ ...prev, name: e.target.value }))} />
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setOpenPopup(false)} variant="contained" color="error">
//             Cancel
//           </Button>
//           <Button variant="contained" onClick={handleSubmit} className="dialogSubmitBtn">
//             {editId ? 'Update' : 'Submit'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from 'react';
import Style from '../doctors/Doctors.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Tooltip } from '@mui/material';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import { toast } from 'react-toastify';
import {
  getMedicines,
  addMedicine,
  updateMedicine,
  deleteMedicine,
} from '../../apis/medicineSlice';
import SearchClinic from '../../components/Autocomplete/SearchClinic';
import DeleteDialog from '../../components/DeleteDialog';
import CommonAgGrid from '../../components/CommonAgGrid/CommonAgGrid';

export default function Medicine() {
  const dispatch = useDispatch();
  const { medicines, loading, totalCount } = useSelector(
    (state) => state.medicineData || { medicines: [], loading: false, totalCount: 0 },
  );

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [openPopup, setOpenPopup] = useState(false);
  // Updated initial state to include qty
  const [medicineData, setMedicineData] = useState({ name: '', qty: '', clinicId: null });
  const [editId, setEditId] = useState(null);

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);

  useEffect(() => {
    dispatch(getMedicines({ page, pageSize }));
  }, [dispatch, page, pageSize]);

  const handleOpenAdd = () => {
    setEditId(null);
    setMedicineData({ name: '', qty: '', clinicId: null });
    setOpenPopup(true);
  };

  const handleOpenEdit = (row) => {
    setEditId(row._id);
    setMedicineData({
      name: row.name,
      qty: row.qty || '', // fallback to empty if qty is missing
      clinicId: row.clinicId || null,
    });
    setOpenPopup(true);
  };

  const handleSubmit = async () => {
if(!medicineData.clinicId){
      return toast.error('Please select clinic');
    } 

    if (!medicineData.name || !medicineData.name.trim()) {
      toast.error('Name is required');
      return;
    }

    // Optional: validate qty is a positive number
    if (medicineData.qty === '' || isNaN(medicineData.qty) || Number(medicineData.qty) < 0) {
      toast.error('Please enter a valid quantity (non-negative number)');
      return;
    }

    let response;

    if (editId) {
      response = await dispatch(
        updateMedicine({
          id: editId,
          name: medicineData.name,
          qty: Number(medicineData.qty),
          clinicId: medicineData.clinicId,
        }),
      );
    } else {
      response = await dispatch(
        addMedicine({
          name: medicineData.name,
          qty: Number(medicineData.qty),
          clinicId: medicineData.clinicId,
        }),
      );
    }

    if (response?.payload?.message) {
      toast.success(response.payload.message);
      setOpenPopup(false);
      dispatch(getMedicines({ page, pageSize }));
    } else {
      toast.error(response?.payload?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    const response = await dispatch(deleteMedicine(row._id));

    if (response?.payload?.message) {
      toast.success(response.payload.message);
      dispatch(getMedicines({ page, pageSize }));
    } else {
      toast.error('Error deleting medicine');
    }
  };

  const handleDeleteClick = (row) => {
    setDeleteRow(row);
    setDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteRow) return;
    await handleDelete(deleteRow);
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  const columns = useMemo(
    () => [
      {
        field: 'actions',
        headerName: 'Actions',
        width: 120,
        sortable: false,
        cellRenderer: (params) => (
          <div style={{ display: 'flex', gap: 4 }}>
            <Tooltip title="Edit">
              <IconButton size="small" color="primary" onClick={() => handleOpenEdit(params.data)}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton size="small" color="error" onClick={() => handleDeleteClick(params.data)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
      {
        field: 'clinicName',
        headerName: 'Clinic Name',
        minWidth: 170,
        valueGetter: (params) => params.data?.clinicId?.name || 'N/A',
      },
      { field: 'name', headerName: 'Name', minWidth: 220 },
      {
        field: 'qty',
        headerName: 'Quantity',
        minWidth: 110,
        valueGetter: (params) => params.data?.qty || 0,
      },
    ],
    [],
  );

  const disabled = !medicineData.clinicId || !medicineData.name.trim() 

  return (
    <div className={Style.mainDataTable}>
      <DeleteDialog
        open={deleteOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
      <Card className={Style.tableCard}>
        <div className={Style.tableHeader}>
          <h2 className={Style.tableTitle}>Medicines</h2>
          <Button
            className={Style.addBtn}
            variant="contained"
            size="small"
            startIcon={<LocalPharmacyIcon />}
            onClick={handleOpenAdd}
          >
            Add Medicine
          </Button>
        </div>
        <CommonAgGrid
          rowData={medicines || []}
          columnDefs={columns}
          getRowId={(row) => String(row.data?._id)}
          loading={loading}
          height={280}
          pagination
          paginationMode="server"
          rowCount={Number(totalCount) || 0}
          pageSizeOptions={[5, 10, 25, 50]}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page);
            setPageSize(model.pageSize);
          }}
        />
      </Card>

      <Dialog
        open={openPopup}
        fullWidth
        maxWidth={'sm'}
        onClose={() => setOpenPopup(false)}
        PaperProps={{ sx: { borderRadius: 2, border: '1px solid var(--color-border-soft)' } }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: 'var(--color-heading)', borderBottom: '1px solid var(--color-border-soft)' }}>
          {editId ? 'Edit Medicine' : 'Add Medicine'}
        </DialogTitle>

        <DialogContent sx={{ '& .MuiInputBase-root': { fontSize: '0.84rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' } }}>
          <div style={{ margin: '12px 0' }}>
            <SearchClinic
              open={openPopup}
              setData={setMedicineData}
              data={medicineData}
              name="clinicId"
              label="Clinic"
              size="small"
            />
          </div>

          <TextField
            size="small"
            autoFocus
            margin="dense"
            required
            label="Medicine Name"
            fullWidth
            value={medicineData.name}
            onChange={(e) => setMedicineData((prev) => ({ ...prev, name: e.target.value }))}
            style={{ marginBottom: 16 }}
          />

          {/* New Quantity Field */}
          <TextField
            size="small"
            margin="dense"
            required
            label="Quantity"
            type="number"
            fullWidth
            value={medicineData.qty}
            onChange={(e) => setMedicineData((prev) => ({ ...prev, qty: e.target.value }))}
            inputProps={{ min: 0 }}
          />
        </DialogContent>

        <DialogActions sx={{ borderTop: '1px solid var(--color-border-soft)', p: 1.25 }}>
          <Button
            onClick={() => setOpenPopup(false)}
            sx={{ textTransform: 'none', borderRadius: '8px', border: '1px solid var(--color-border-soft)', color: 'var(--color-heading)' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            className={ disabled ? "dialogDisableBtn" :"dialogSubmitBtn"}
            disabled={disabled}
            sx={{ textTransform: 'none', borderRadius: '8px', boxShadow: 'none' }}
          >
            {editId ? 'Update' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
